import { spanWrapText } from "./libs";
import setTextAnim from "./setTextAnim";
import { gsap } from 'gsap'

const setTopAnim = () => {
  const hero = document.querySelector('.js-section-hero');
  if (!hero) return false;

  const
    Kv = hero.querySelector('.js-hero-kv img'),
    Title = hero.querySelectorAll('.js-hero-title'),
    News = hero.querySelector('.js-hero-news'),

    Logo = document.querySelector('.js-brand-logo'),
    Gn = document.querySelector('#js-gn-menu'),

    Concept = document.querySelector('.section-concept');

  spanWrapText(Title);
  const TitleChar = Title[0].querySelectorAll('.char');

  gsap.set(TitleChar, {
    display: 'inline-block',
  })

  gsap
    .timeline()
    .from(Kv,
      {
        scale: 1.05,
        opacity: 0,
        duration: 1.4,
        ease: 'quad.out',
      }
    )
    .from(Logo,
      {
        autoAlpha: 0,
        y: -50,
        duration: 1,
        ease: 'quad.out',
      },'<0.1'
    )
    .fromTo(TitleChar,
      {
        autoAlpha: 0,
      },
      {
        autoAlpha: 1,
        duration: 0.8,
        ease: 'sine.inOut',
        stagger: 0.02,
      },'<0.4'
    )
    // .from(Gn,
    //   {
    //     autoAlpha: 0,
    //     duration: 1,
    //      ease: 'quad.out',
    //   },
    //   '<0.5'
    // )
    .from(News,
      {
        autoAlpha: 0,
        duration: 1,
        ease: 'quad.out',
        onComplete: () => {
          setTextAnim(); 
        }
      }, '>'

    )

    // .from(Concept,
    //   {
    //     autoAlpha: 0,
    //     y: 100,
    //     duration: 1.5,
    //     ease: 'power3.out',
    //   },'<1'
    // )
}

export default setTopAnim;